import React from "react";

const Video = ({id=1}) => {
  return (
    <div className="gallery-item" id={`container-video-${id}`}>
      <video id={`video-${id}`} 
        tabindex="-1" role="application" 
        class="vjs-tech" preload="metadata" 
        playsinline="playsinline" 
        src="blob:https://www.linkedin.com/8b7f1e2a-c008-4016-aaee-1949622cd13b">
      </video>    
    </div>
  );
};

export {Video}